import { Match, Result } from 'effect'
import type { ZodType } from 'zod'

export interface MapAllPropertiesError {
  message: 'スキーマ検証に失敗しました'
  options: {
    value: unknown
  }
}

export const mapAllProperties = <T>(
  value: T,
  map: Record<string, string>,
  schema: ZodType<T>,
): Result.Result<T, MapAllPropertiesError> => {
  const seen = new WeakSet<object>()

  const process = (input: unknown): unknown => {
    // 循環参照チェック
    if (typeof input === 'object' && input !== null) {
      if (seen.has(input)) {
        return input // 循環参照が検出された場合、元の値を返す
      }
      seen.add(input)
    }

    return Match.value(input).pipe(
      Match.when(Match.string, (s) => map[s] ?? s),
      Match.when(Array.isArray, (array) => array.map(process)),
      Match.when(
        (v: unknown): v is Record<string, unknown> => typeof v === 'object' && v !== null && !Array.isArray(v),
        (object) => Object.fromEntries(Object.entries(object).map(([key, value_]) => [key, process(value_)])),
      ),
      Match.orElse((v) => v),
    )
  }
  const result = schema.safeParse(process(value))
  return result.success
    ? Result.succeed(result.data)
    : Result.fail({
        message: 'スキーマ検証に失敗しました',
        options: { value },
      })
}
